import { clamp, glow, mulberry32, TAU, type DrawFn } from '../lib/math'

export function createAfterglow(): DrawFn {
  const rng = mulberry32(64)
  const coals = Array.from({ length: 22 }, () => ({
    a: rng() * TAU,
    r: rng() * 40,
    s: 1 + rng() * 2.2,
    o: rng() * TAU,
  }))

  return (ctx, t, w, h) => {
    const cx = w * 0.5
    const cy = h * 0.42
    ctx.clearRect(0, 0, w, h)
    const cool = clamp(t / 8)
    const breath = 0.75 + Math.sin(t * (1.4 - cool * 0.7)) * (0.25 - cool * 0.12)
    const intro = clamp(t / 1.1)

    ctx.globalCompositeOperation = 'lighter'
    glow(ctx, cx, cy, 140 * breath, `rgba(255,80,20,${(0.16 - cool * 0.08) * intro})`)
    glow(ctx, cx, cy, 40 * breath, `rgba(255,160,70,${(0.28 - cool * 0.1) * intro})`)

    for (const c of coals) {
      const tw = 0.4 + 0.6 * Math.abs(Math.sin(t * 1.3 + c.o))
      ctx.fillStyle = `rgba(255,${90 + tw * 80 | 0},30,${tw * 0.55 * intro * (1 - cool * 0.4)})`
      ctx.beginPath()
      ctx.arc(cx + Math.cos(c.a) * c.r, cy + Math.sin(c.a) * c.r * 0.5, c.s, 0, TAU)
      ctx.fill()
    }

    ctx.globalCompositeOperation = 'source-over'
  }
}
